import { useEffect, useState } from "react"
import { Table } from "antd"
import Column from "antd/lib/table/Column"
import { baseAxiosNoInfo } from "../../../tool/axios"

interface Prop {
    dealID?: string
}

export default function (prop: Prop) {

    const [data, setData] = useState<any[]>([])

    useEffect(() => {
        if (prop.dealID) {
            baseAxiosNoInfo('/yuesao_center/customer/detail/nursing_work_detail_records', {
                params: {
                    deal_id: prop.dealID,
                }
            }).then((res: any) => {
                res && setData(res)
            })
        }
    }, [prop.dealID])

    return <div className="follow-record">
        {/* 月嫂中心 -> 客户管理 -> 客户详情 -> 服务操作记录 */}
        <Table pagination={false} scroll={{ x: 'max-content' }} style={{ width: '95%' }} dataSource={data}>
            <Column title="业务类型" dataIndex="business_type_desc" />
            <Column title="护理师" dataIndex="belong_nursing_name" />
            <Column title="操作人" dataIndex="opereator_user_name" />
            <Column title="操作时间" dataIndex="opereator_time" />
        </Table>
    </div>
}